import { render, staticRenderFns } from "./salespromotion.vue?vue&type=template&id=bf7616dc&"
import script from "./salespromotion.vue?vue&type=script&lang=js&"
export * from "./salespromotion.vue?vue&type=script&lang=js&"
import style0 from "./salespromotion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports